<ng-container *ngIf="(columnClasses$ | async) as classes">
    <app-loading-table [columns]="keys" [columnClasses]="classes"></app-loading-table>
    <ng-container *ngIf="!(mobileMode$ | async)">
        <app-loading-table [columns]="keys" [columnClasses]="classes"></app-loading-table>
        <app-loading-table [columns]="keys" [columnClasses]="classes"></app-loading-table>
    </ng-container>
</ng-container>
